module.exports = __webpack_public_path__ + "static/media/EB14.dd97e841.png";